import './App.css';
import Navigation from './navigation/Navigation';
import { useSocket } from './Contexts/SocketContext';
import React, { useEffect, useRef } from 'react';
import ToastNotification from './common/ToastNotification';

const MainComponent = () => {
  const { socketInstance, makeUserOnline } = useSocket();
  const notificationSound = require('./assets/sounds/notificationSound.wav');

  const audioRef = useRef(new Audio(notificationSound));

  const truncateMessage = (message: any, maxLength: any) => {
    return message.length > maxLength ? `${message.slice(0, maxLength)}...` : message;
  };

  useEffect(() => {
    if (socketInstance) {
      socketInstance.on('updateNotifications', (notification: any) => {
        if (notification.message) {
          ToastNotification({
            message: notification.message,
            type: 'info'
          });
        }
      });
      socketInstance.on('customer-to-user-message', (response: any) => {
        if (response?.message) {
          ToastNotification({
            message: truncateMessage(response.message, 25),
            type: 'info'
          });
          audioRef.current.play().catch((error) => console.error('Audio play error:', error));
        }
      });
      return () => {
        socketInstance.off('notifications');
        socketInstance.off('getNotifications');
        socketInstance.off('searchNotifications');
        socketInstance.off('updateNotifications');
        socketInstance.off('customer-to-user-message');
      };
    }
  }, [socketInstance]);

  useEffect(() => {
    if (socketInstance) {
      makeUserOnline();
      const intervalId = setInterval(() => {
        makeUserOnline();
      }, 30 * 1000);

      return () => clearInterval(intervalId);
    }
  }, [socketInstance]);

  return <Navigation />;
};

export default MainComponent;
